import styles from '@fukku/input/Input.module.css'
import type { ErrorMessageProps } from '@fukku/input/types'
import textBodyS from '@fukku/styles/texts/textBodyS.module.css'
import { cx } from 'classix'
import { ClientLabel } from 'labels/components/ClientLabel/ClientLabel'

export function ErrorMessage({
	children,
	errorMessageId,
	errorPlaceholders,
	'data-testid': dataTestId,
}: Readonly<ErrorMessageProps>) {
	if (!children) {
		return null
	}

	return (
		<p
			className={cx(textBodyS.className, styles.errorMessage, styles.showError)}
			id={errorMessageId}
			aria-live='polite'
			data-testid={dataTestId}
		>
			<ClientLabel placeholderValues={errorPlaceholders}>
				{children}
			</ClientLabel>
		</p>
	)
}
